import { TFunction } from 'i18next'
import { z } from 'zod'

export const createBankAccountFormSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, {
      message: t('required'),
    }),
    accountNumber: z.string().min(1, {
      message: t('required'),
    }),
    accountCurrency: z.string().min(1, {
      message: t('required'),
    }).regex(new RegExp(/^[A-Z]{3}$/), {
      message: t('isoCode'),
    }),
    accountHolderName: z.string().min(1, {
      message: t('required'),
    }),
    beneficiaryBankName: z.string().min(1, {
      message: t('required'),
    }),
    beneficiaryBankAddress: z.string().min(1, {
      message: t('required'),
    }),
    taxId: z.string().min(1, {
      message: t('required'),
    }),
    correspondentSwiftBicCode: z.string().min(1, {
      message: t('required'),
    }),
    description: z.string().min(1, {
      message: t('required'),
    })
  })

